import {
  DemographicRelation
} from "../../../pages/ADGROUP/zeus/AdGroupModelZeus";
import {
  options_gender,
  options_pref
} from "../../../atom/Apollo_styles";
import {arrayChunk} from "../../Apollo_CommonUtil";
import {OsTargeting} from "../../../pages/ADGROUP/zeus/AdGroupModelZeus";
import {Asset} from "../../../pages/ADVERTISEMENT/zeus/AdvertisementModelZeus";

export type DemographicData = {
  genders: string[],
  address: string[],
  ageRanges: number[],
}

export type AssetData = {
  images: number[],
  title: string[],
  description: string[],
}

const SCHEDULES_WEEKS_ZEUS = ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"];

export const formatLogFromSchedule = function (
  schedule: string,
): string[] {
  const list: string[] = [];
  const array = schedule.replace(/[\[\],]/g, "").split('');
  const scheduleArray = arrayChunk(array, 24);
  scheduleArray?.map((values: string[], key: number) => {
    const hours: number[] = [];
    values?.map((value: string, key: number) => {
      if (value === "1") hours.push(key);
    });
    list.push(`${SCHEDULES_WEEKS_ZEUS[key]}：${hours.join(",")}`);
  });
  return list;
}

const valueToLabel = function (value: any, options: Array<{ value: any; label: string }>): string {
  let option = options?.find(option => option.value === value)
  if (!option) {
    return ""
  } else {
    return option.label
  }
}

export const formatLogFromDemographics = function (
  demographiccRelations: DemographicRelation[]
): DemographicData {
  const data: DemographicData = {
    genders: [],
    address: [],
    ageRanges: [],
  }

  if (demographiccRelations.length > 0) {
    demographiccRelations[0].genderCodeList?.split(",").map((value : any) => {
      const gender = valueToLabel(value, options_gender);
      data.genders.push(gender);
    });
    demographiccRelations[0].prefCodeList?.split(",").map((value : any) => {
      const address = valueToLabel(value, options_pref);
      data.address.push(address);
    });
    if (demographiccRelations[0].ageMin != null) {
      data.ageRanges[0] = demographiccRelations[0].ageMin;
    }
    if (demographiccRelations[0].ageMax != null) {
      data.ageRanges[1] = demographiccRelations[0].ageMax;
    }
  }
  return data;
}

export const formatLogFromOsTargeting = function (
  osTargetings: OsTargeting[],
): string[] {
  const list: string[] = [];
  osTargetings?.map((os) => {
    const name = os.osType === 1 ? "Android" : "iOS";
    list.push(`${name}`);
  });
  return list;
}

export const formatLogFromAssets = function (
  assets: Asset[],
): AssetData {
  const data: AssetData = {
    images: [],
    title: [],
    description: [],
  }
  assets?.map((asset) => {
    const idx = asset.index;
    switch (idx) {
      case 1:
        if (asset?.img?.accountImageResourceId && asset.img.accountImageResourceId > 0) {
          data.images.push(asset.img.accountImageResourceId);
        }
        break;

      case 2:
        if (asset?.title?.text && asset.title.text !== "") {
          data.title.push(asset.title?.text);
        }
        break;

      case 3:
        if (asset?.description?.text && asset.description.text !== "") {
          data.description.push(asset.description?.text);
        }
        break;
    }
  });
  return data;
}
